import { useEffect, useRef, useState } from "react";
import { Eraser, PenLine } from "lucide-react";
import { useLang } from "../context/LangContext";

export default function SignaturePad({ onChange }) {
  const { t } = useLang();
  const ref = useRef();
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const ctx = c.getContext("2d");
    ctx.lineWidth = 2.5; ctx.lineCap = "round"; ctx.strokeStyle = "#e2e8f0";
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return [((p.clientX - r.left) * ref.current.width) / r.width, ((p.clientY - r.top) * ref.current.height) / r.height];
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); setEmpty(false); };
  const end = () => { if (!drawing.current) return; drawing.current = false; onChange(ref.current.toDataURL("image/png")); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange(null); };

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-slate-400 flex items-center gap-1"><PenLine className="w-3 h-3" />{t("signature")}</span>
        <button type="button" data-testid="signature-clear-btn" onClick={clear} className="text-xs text-slate-400 hover:text-white flex items-center gap-1"><Eraser className="w-3 h-3" />{t("clear")}</button>
      </div>
      <canvas
        ref={ref}
        data-testid="signature-canvas"
        width={480}
        height={160}
        className="w-full h-32 rounded-xl bg-white/5 border border-dashed border-white/15 touch-none cursor-crosshair"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
      />
      {empty && <div className="text-[11px] text-slate-500 mt-1">{t("signature_hint")}</div>}
    </div>
  );
}
